import Page from "@/components/Page"
import HeroImage from "@/components/HeroImage"
import { Button } from "@/components/chadcn/Button"
import measurementImageUrl from "@/assets/measurement.svg"
import bloomlifeLogoUrl from "@/assets/bloomlife-logo.svg"

type WelcomeStepProps = {
  onNext: () => void
}

const WelcomeStep = ({ onNext }: WelcomeStepProps) => (
  <Page showAppbar={false}>
    <HeroImage src={measurementImageUrl} alt="health-measurement" />
    <div className="flex min-h-[calc(100vh-40vh-56px)] flex-col justify-between gap-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <img alt="logo" src={bloomlifeLogoUrl} className="w-[220px]" />
        <p className="text-base text-primary-contrast">
          Your doctor has enrolled you in Bloomlife Connects
          <br />
          <br />
          Bloomlife Connects is a remote care platform that helps you and your
          doctor track your blood glucose levels
        </p>
      </div>
      <Button type="button" className="w-full py-2 text-base" onClick={onNext}>
        Let&apos;s set up your profile
      </Button>
    </div>
  </Page>
)

export default WelcomeStep
